import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const RoomRequest = React.lazy(() => import("./RequestList"));
const CreateRequest = React.lazy(() => import("./CreateRequest"));
const BookingLogs = React.lazy(() => import("./BookingLogs"));
const BookingDetails = React.lazy(() => import("./BookingDetails"));
const ApprovalRequest = React.lazy(() => import("./ApprovalRequest"));
const FrontDeskRequest = React.lazy(() => import("./FrontDeskRequest"));
//const FrontDesklogs = React.lazy(() => import("./FrontDeskLogs"));
const KitchenAccomodation = React.lazy(() => import("./KitchenAccomodation"));
const CreateRoomList = React.lazy(() => import("./CreateRoomList"));
// const LocationList = React.lazy(() => import("./LocationList"));
export const RoomBookingConfig = [
    {
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
        ],
        path: "/room/booking-request",
        element: <RoomRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
        ],
        path: "/room/create-request",
        element: <CreateRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
        ],
        path: "/room/edit-request/:id",
        element: <CreateRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/room/booking-detail/:id",
        element: <BookingDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/room/logs",
        element: <BookingLogs />,
    },
    {
        permittedRole: [RoutePermittedRole.LOCATION_MANAGER],
        path: "/room/approval-request",
        element: <ApprovalRequest />,   
    },
    {
        permittedRole: [RoutePermittedRole.FRONTDESK],
        path: "/room/frontdesk-request",
        element: <FrontDeskRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
        ],
        path: "/room/check-in-user",
        element: <KitchenAccomodation />,
    },
    {
        permittedRole: [RoutePermittedRole.LOCATION_MANAGER],
        path: "/room/list",
        element: <CreateRoomList />,
    },
];
